import dayjs from "dayjs";

export function validateBookingDates({ date_from, date_to }) {
  for (const value of [date_from, date_to]) {
    if (value && (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !dayjs(value).isValid() || dayjs(value).format("YYYY-MM-DD") !== value)) return "Please enter a valid date.";
  }
  return date_from && date_to && date_from > date_to ? "Date From must be on or before Date To." : "";
}
